import React from 'react'
import {
    Typography,
    Grid,
    Container,
    Avatar,
    makeStyles
} from '@material-ui/core'
import {
    ArrowBack
} from '@material-ui/icons'
import { CustomAppBar, CustomButton } from '../../../shared'
import { Group } from '../../../assets/images'
import { getContent } from '../../../utils/helper'
import { supportedLanguageMapping } from '../../language/constants'

const useStyles = makeStyles(theme => ({
    avatarContainer: {
        width: '100%',
        height: 200,
        '& img': {
            objectFit: 'contain'
        }
    }
}));

const Instructions = ({ goBack, goToScreen, language, languageJSON, requestDetails }) => {
    const classes = useStyles()
    return (
        <div>
            <CustomAppBar title={getContent(languageJSON, 'title_instructions')}
            leftButton={<CustomButton variant="text" handleChange={goBack} label={<ArrowBack />} />}
            rightButton={<CustomButton variant="text" color="primary" handleChange={() => goToScreen('language', { to: 'instructions' })} label={supportedLanguageMapping[language]} />}/>
            <Container style={{ height: '90vh', backgroundColor: '#f7fdfd'  }}>
                <Grid container justify="center" alignItems="center" style={{ padding: '2%', maxHeight: '100vh', overflow: 'scroll', paddingBottom: 150 }}>
                    <Grid item xs={11}>
                        <Typography variant="h6">
                            {getContent(languageJSON, 'subtitle_verify_address')}
                        </Typography>
                    </Grid>
                    <Grid item xs={11} style={{ marginTop: '5%' }}>
                        <Typography variant="body1">
                            {getContent(languageJSON, 'text_role_explain', requestDetails)}
                        </Typography>
                    </Grid>
                    <Grid item xs={11} style={{ marginTop: '10%' }}>
                        <Avatar className={classes.avatarContainer} variant={"square"} src={Group}/>
                    </Grid>
                </Grid>
                <Grid container justify="center" alignItems="center" style={{ padding: '15px', position: 'absolute', bottom: 0, left: 0, backgroundColor: '#f7fdfd' }}>
                    <Grid item xs={11}>
                        <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%', fontSize: 12 }} color="primary" handleChange={() => goToScreen('addressVerification')} 
                            label={<Typography variant="button">{getContent(languageJSON, 'action_next')}</Typography>} />
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default Instructions